var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBack = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 21,
  height: 20,
  viewBox: "0 0 21 20",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "prefix__a",
  d: "M15.562 10.781c-.28-.311-.8-.35-1.121-.078l-5.37 4.474V1.445c0-.428-.36-.778-.801-.778-.44 0-.801.35-.801.778v13.732l-5.37-4.474c-.36-.31-.84-.272-1.161.078-.28.311-.24.817.08 1.09l6.691 5.601c.16.117.32.195.521.195.2 0 .36-.078.52-.195l6.732-5.602c.32-.272.36-.778.08-1.089"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 0L20 0 20 21 10 21 0 21 0 0z",
  transform: "rotate(90 10.493 10.49)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(90 10.493 10.49) translate(1.25 1.333)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "prefix__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#B2B2B2",
  xlinkHref: "#prefix__a"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#191919",
  mask: "url(#prefix__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H21V20H0z",
  transform: "translate(-1.75 -.833)"
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/back.8df3c2d99df72f354e36e6e1c7b021ba.svg";